import * as React from 'react';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { IconList } from 'ui';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { ComponentProps } from 'ui/common';
import { FactItemProps } from 'app/area/case/components/fact-box/types';

interface ConnectedCasesBowtieFactItemProps extends ComponentProps, FactItemProps {
  connectedBowtieSupported: boolean;
  defaultIcon?: JSX.Element;
  primaryKey?: { value: string };
}

export const ConnectedCasesBowtieFactItem = (props: ConnectedCasesBowtieFactItemProps) => {
  const { title, defaultIcon, connectedBowtieSupported, tooltip, primaryKey } = props;
  const iconBowtieAbsolutePath = toAbsoluteUrl('i/bowtie.svg');
  const icons = [{ description: tooltip, icon: iconBowtieAbsolutePath, value: 0, propName: 'bowtie' }];

  if (!connectedBowtieSupported) {
    return null;
  }

  return <FactLink id={props.componentId} classNames={`fact-item icon-line`} url={`/bowtie/${primaryKey?.value}`}>
    <IconList title={title} valueItems={icons} defaultIcon={defaultIcon} />
  </FactLink>;
};
